//行政模块
export const leaveApply = { //请假申请
  path: '/leaveApply',
  name: 'leaveApply',
  component: () => import('@/views/myPost/administrative/leaveApply.vue')
}
export const meetingApply = { //会议室申请
  path: '/meetingApply',
  name: 'meetingApply',
  component: () => import('@/views/myPost/administrative/meetingApply.vue')
}
export const fillUpCard = { //补卡申请
  path: '/fillUpCard',
  name: 'fillUpCard',
  component: () => import('@/views/myPost/administrative/fillUpCard.vue')
}
export const businessTripApply = { //出差申请
  path: '/businessTripApply',
  name: 'businessTripApply',
  component: () => import('@/views/myPost/administrative/businessTripApply.vue')
}
export const businessChangeApply = { //出差变更申请
  path: '/businessChangeApply',
  name: 'businessChangeApply',
  component: () => import('@/views/myPost/administrative/businessChangeApply.vue')
}
export const gooutApply = { //外出申请
  path: '/gooutApply',
  name: 'gooutApply',
  component: () => import('@/views/myPost/administrative/gooutApply.vue')
}
export const receptionApply = { //接待申请
  path: '/receptionApply',
  name: 'receptionApply',
  component: () => import('@/views/myPost/administrative/receptionApply.vue')
}
export const overTimeApply = { //加班申请
  path: '/overTimeApply',
  name: 'overTimeApply',
  component: () => import('@/views/myPost/administrative/overTimeApply.vue')
}

//物资模块
export const vehicleApply = { //用车申请
  path: '/vehicleApply',
  name: 'vehicleApply',
  component: () => import('@/views/materialsModule/vehicle/vehicleApply.vue')
}

export const vehicleManage = { //车辆管理
  path: '/vehicleManage',
  name: 'vehicleManage',
  component: () => import('@/views/materialsModule/vehicle/vehicleManage.vue')
}
export const vehicleRetrun = { //车辆归还
  path: '/vehicleRetrun',
  name: 'vehicleRetrun',
  component: () => import('@/views/materialsModule/vehicle/vehicleRetrun.vue')
}
export const veicleRetrunDetail = { //车辆归还
  path: '/veicleRetrunDetail',
  name: 'veicleRetrunDetail',
  component: () => import('@/views/materialsModule/vehicle/veicleRetrunDetail.vue')
}
export const vehicleDispatch = { //车辆出库
  path: '/vehicleDispatch',
  name: 'vehicleDispatch',
  component: () => import('@/views/materialsModule/vehicle/vehicleDispatch.vue')
}

export const sealApply = { //印章申请
  path: '/sealApply',
  name: 'sealApply',
  component: () => import('@/views/materialsModule/seal/sealApply.vue')
}

export const procurementManage = { //采购编辑
  path: '/procurementManage',
  name: 'procurementManage',
  component: () => import('@/views/materialsModule/procurement/procurementManage.vue')
}
export const materialApplication = { //物资申领 新增/编辑
  path: '/materialApplication',
  name: 'materialApplication',
  component: () => import('@/views/materialsModule/materialApplication/materialApplication.vue')
}
export const suppliesManage = { // 资产 编辑
  path: '/suppliesManage',
  name: 'suppliesManage',
  component: () => import('@/views/materialsModule/suppliesManage/suppliesManage.vue')
}
export const addSupplies = { //采购新增
  path: '/addSupplies',
  name: 'addSupplies',
  component: () => import('@/views/materialsModule/suppliesManage/addSupplies.vue')
}
//财务模块
export const reimbursement = { //报销 新增/编辑 
  path: '/reimbursement',
  name: 'reimbursement',
  component: () => import('@/views/financeModule/reimbursement/reimbursement.vue')
}
export const loanApplication = { //借款 新增/编辑 
  path: '/loanApplication',
  name: 'loanApplication',
  component: () => import('@/views/financeModule/loanApplication/loanApplication.vue')
}
export const marginApplication = { //保证金 新增/编辑 
  path: '/marginApplication',
  name: 'marginApplication',
  component: () => import('@/views/financeModule/marginApplication/marginApplication.vue')
}

export const payment = { //付款申请 新增/编辑 （旧）
  path: '/payment',
  name: 'payment',
  component: () => import('@/views/financeModule/payment/payment.vue')
}
export const capitalManage = { //资金 新增/编辑 
  path: '/capitalManage',
  name: 'capitalManage',
  component: () => import('@/views/financeModule/capitalManage/capitalManage.vue')
}
export const otherCapital = { //其他申请 新增/编辑 
  path: '/otherCapital',
  name: 'otherCapital',
  component: () => import('@/views/financeModule/otherCapital/otherCapital.vue')
}
export const invoiceManage = { //项目开票申请
  path: '/invoiceManage',
  name: 'invoiceManage',
  component: () => import('@/views/financeModule/invoiceManage/invoiceManage.vue')
}
export const invoiceRecord = { //财务开票历史 详情 
  path: '/invoiceRecord',
  name: 'invoiceRecord',
  component: () => import('@/views/financeModule/invoiceManage/invoiceRecord.vue')
}

export const arrivalManage = { //财务到账历史 查看
  path: '/arrivalManage',
  name: 'arrivalManage',
  component: () => import('@/views/financeModule/arrivalManage/arrivalManage.vue')
}
export const returnInvoice = { //财务开票回款详情    查看/新增/撤销
  path: '/returnInvoice',
  name: 'returnInvoice',
  component: () => import('@/views/financeModule/arrivalManage/kphk/returnInvoice.vue')
}

export const returnJk = { //财务借款回款详情    查看/新增/撤销
  path: '/returnJk',
  name: 'returnJk',
  component: () => import('@/views/financeModule/arrivalManage/jkhk/returnJk.vue')
}
export const returnBzj = { //财务保证金回款详情    查看/新增/撤销
  path: '/returnBzj',
  name: 'returnBzj',
  component: () => import('@/views/financeModule/arrivalManage/bzjhk/returnBzj.vue')
}
export const delHkList = { //回款详情列表    
  path: '/delHkList',
  name: 'delHkList',
  component: () => import('@/views/financeModule/arrivalManage/delHkList/delHkList.vue')
}

export const financialManage = { //财务办理 新增/编辑 
  path: '/financialManage',
  name: 'financialManage',
  component: () => import('@/views/financeModule/financialManage/financialManage.vue')
}
//我的
export const leaveOffice = { //离职申请
  path: '/leaveOffice',
  name: 'leaveOffice',
  component: () => import('@/views/myPost/leaveOffice.vue')
}
export const promotionOffice = { //转正申请
  path: '/promotionOffice',
  name: 'promotionOffice',
  component: () => import('@/views/myPost/promotionOffice.vue')
}
export const probationOffice = { //转试用申请
  path: '/probationOffice',
  name: 'probationOffice',
  component: () => import('@/views/myPost/probationOffice.vue')
}
export const assignOffice = { //转岗申请
  path: '/assignOffice',
  name: 'assignOffice',
  component: () => import('@/views/myPost/assignOffice.vue')
}
export const company = { //公司信息
  path: '/company',
  name: 'company',
  component: () => import('@/views/company/companyMsg.vue')
}
export const salaryDetail = { //工资条详情
  path: '/salaryDetail',
  name: 'salaryDetail',
  component: () => import('@/views/user/salaryDetail.vue')
}

export const credential = { //资质证书明细
  path: '/credential',
  name: 'credential',
  component: () => import('@/views/user/credential.vue')
}
export const diploma = { //学历证书明细
  path: '/diploma',
  name: 'diploma',
  component: () => import('@/views/user/diploma.vue')
}
export const propertyDetail = { //资产领用明细
  path: '/propertyDetail',
  name: 'propertyDetail',
  component: () => import('@/views/user/myManage/propertyDetail.vue')
}
export const myCheckingIn = { //签到记录
  path: '/myCheckingIn',
  name: 'myCheckingIn',
  component: () => import('@/views/user/myCheckingIn/myCheckingIn.vue')
}
export const calendar = { //日历
  path: '/calendar',
  name: 'calendar',
  component: () => import('@/views/user/myCheckingIn/calendar.vue')
}
export const activityDetail = { //活动报名详情
  path: '/activityDetail',
  name: 'activityDetail',
  component: () => import('@/views/activity/activityDetail.vue')
}
export const activityForm = { //活动表单详情
  path: '/activityForm',
  name: 'activityForm',
  component: () => import('@/views/activity/activityFormTwo.vue')
}
//项目管理
export const budgetInfo = { //收支统计
  path: '/budgetInfo',
  name: 'budgetInfo',
  component: () => import('@/views/projectModule/budgetInfo.vue')
}
//项目借款详情
export const borrowJkPage = { //收支统计
  path: '/borrowJkPage',
  name: 'borrowJkPage',
  component: () => import('@/views/projectModule/borrowJkPage.vue')
}
//项目保证金详情
export const marginBzjPage = { //收支统计
  path: '/marginBzjPage',
  name: 'marginBzjPage',
  component: () => import('@/views/projectModule/marginBzjPage.vue')
}

//新闻详情
export const newsDetail = { //新闻详情
  path: '/newsDetail',
  name: 'newsDetail',
  component: () => import('@/views/news/newsDetail.vue')
}
//通知详情
export const notification = { //通知详情
  path: '/notification',
  name: 'notification',
  component: () => import('@/views/notification/notification.vue')
}
//记事
export const keepRecord = { //记事
  path: '/keepRecord',
  name: 'keepRecord',
  component: () => import('@/views/user/keepRecord/keepRecordDetail.vue')
}
//个人数据中心
export const userSource = { //个人数据中心
  path: '/userSource',
  name: 'userSource',
  component: () => import('@/views/user/userSource.vue')
}
//测试活动

export const activityFormTwo = { //新版本活动表单
  path: '/activityFormTwo',
  name: 'activityFormTwo',
  component: () => import('@/views/activity/activityFormTwo.vue')
}

//财务开票
export const cwkp = { //财务开票操作
  path: '/cwkp',
  name: 'cwkp',
  component: () => import('@/views/financeModule/invoiceManage/cwkp/cwkp.vue')
}

//作废的开票
export const badInvoice = { //作废的开票详情
  path: '/badInvoice',
  name: 'badInvoice',
  component: () => import('@/views/financeModule/invoiceManage/cwkp/badInvoice.vue')
}
//申请的作废开票
export const myAbolishInvoice = { //作废的开票详情
  path: '/myAbolishInvoice',
  name: 'myAbolishInvoice',
  component: () => import('@/views/financeModule/invoiceManage/myInvoice/myAbolishInvoice.vue')
}

//物资归还
export const goodsReturn = { //物资归还 
  path: '/goodsReturn',
  name: 'goodsReturn',
  component: () => import('@/views/materialsModule/materialApplication/goodsReturn.vue')
}
//项目收入明细
export const incomeDetail = { //项目收入明细
  path: '/incomeDetail',
  name: 'incomeDetail',
  component: () => import('@/views/projectModule/incomeDetail.vue')
}
//项目支出明细
export const expendDetail = { //项目收入明细
  path: '/expendDetail',
  name: 'expendDetail',
  component: () => import('@/views/projectModule/expendDetail.vue')
}
//新增项目登记
export const projectRegister = { //项目登记
  path: '/projectRegister',
  name: 'projectRegister',
  component: () => import('@/views/projectModule/projectRegister.vue')
}

//招聘申请
export const recruitPage = {
  path: '/recruitPage',
  name: 'recruitPage',
  component: () => import('@/views/user/recruit/recruitPage.vue')
}
//记事详情
export const shareDetail = {
  path: '/shareDetail',
  name: 'shareDetail',
  component: () => import('@/views/user/keepRecord/shareDetail.vue')
}
//用餐统计
export const haveDinner = {
  path: '/haveDinner',
  name: 'haveDinner',
  component: () => import('@/views/haveDinner/haveDinnerPage.vue')
}

//用户须知及隐私协议
//用户须知
export const userNotice = {
  path: '/userNotice',
  name: 'userNotice',
  component: () => import('@/views/userNotice/userNotice.vue'),

}
//隐私政策
export const privacyPage = {
  path: '/privacyPage',
  name: 'privacyPage',
  component: () => import('@/views/userNotice/privacyPage.vue'),

}
//项目成果出库申请
export const deliveryPage = {
  path: '/deliveryPage',
  name: 'deliveryPage',
  component: () => import('@/views/projectModule/deliveryPage.vue'),

}
//视频会议  暂时
export const videoPage = {
  path: '/videoPage',
  name: 'videoPage',
  component: () => import('@/views/video/videoPage.vue'),
}
//微信  
export const wechat = {
  path: '/wechat',
  name: 'wechat',
  component: () => import('@/views/wechat/wechat.vue'),
}
//微信下 打开通知、新闻、活动跳转得路由
export const wxInformMsg = {
  path: '/wxInformMsg',
  name: 'wxInformMsg',
  component: () => import('@/views/notification/wxNotification.vue'),
}
export const wxNewsDetail = {
  path: '/wxNewsDetail',
  name: 'wxNewsDetail',
  component: () => import('@/views/news/wxNewsDetail.vue'),
}
export const wxActivityDetail = {
  path: '/wxActivityDetail',
  name: 'wxActivityDetail',
  component: () => import('@/views/activity/wxActivityDetail.vue'),
}
//东华分享历程
export const dhShare = {
  path: '/dhShare',
  name: 'dhShare',
  component: () => import('@/views/wechat/dhShare/dhShare.vue'),
}

//报销移交
export const handOver = {
  path: '/handOver',
  name: 'handOver',
  component: () => import('@/views/financeModule/reimbursement/reimbursementHandOver.vue'),
}
//付款移交
export const capitalHandOver = {
  path: '/capitalHandOver',
  name: 'capitalHandOver',
  component: () => import('@/views/financeModule/capitalManage/capitalHandOver.vue'),
}

//新增圈子功能
export const addKeepRecord = {
  path: '/addKeepRecord',
  name: 'addKeepRecord',
  component: () => import('@/views/user/keepRecord/addKeepRecord.vue'),
}

//新增项目奖金申请
export const bonusManage = {
  path: '/bonusManage',
  name: 'bonusManage',
  component: () => import('@/views/financeModule/bonusManage/bonusManage.vue'),
}
//外派培训申请
export const OverseasTrain = {
  path: '/OverseasTrain',
  name: 'OverseasTrain',
  component: () => import('@/views/myPost/trainManage/OverseasTrain.vue'),
}
//培训请假申请
export const trainLeaveApply = {
  path: '/trainLeaveApply',
  name: 'trainLeaveApply',
  component: () => import('@/views/myPost/trainManage/trainLeaveApply.vue'),
}
//物资报废申请
export const materialScrapApply = {
  path: '/materialScrapApply',
  name: 'materialScrapApply',
  component: () => import('@/views/myPost/scrapManage/materialScrapApply.vue'),
}

//培训课程
export const onlineEducation = {
  path: '/onlineEducation',
  name: 'onlineEducation',
  component: () => import('@/views/user/onlineEducation/onlineEducation.vue'),
}
//项目统计
export const projectStatistics = {
  path: '/projectStatistics',
  name: 'projectStatistics',
  component: () => import('@/views/projectModule/projectStatistics'),
}
 
export const routers = [company, salaryDetail, leaveOffice, promotionOffice, assignOffice, keepRecord, activityFormTwo,
  credential, diploma, propertyDetail, myCheckingIn, calendar, activityDetail, probationOffice, userNotice, privacyPage,
  leaveApply,meetingApply, businessTripApply,businessChangeApply,gooutApply, receptionApply, overTimeApply, vehicleApply, userSource, cwkp, badInvoice, veicleRetrunDetail, vehicleDispatch, haveDinner, projectRegister,
  vehicleManage, sealApply, procurementManage, materialApplication, suppliesManage, addSupplies, myAbolishInvoice, vehicleRetrun, shareDetail,
  reimbursement, loanApplication, marginApplication, capitalManage, otherCapital, invoiceManage, invoiceRecord, incomeDetail, expendDetail, recruitPage, deliveryPage,
  arrivalManage, returnInvoice, returnJk, returnBzj, delHkList, financialManage, budgetInfo, notification, newsDetail, payment, fillUpCard, activityForm, borrowJkPage, marginBzjPage, videoPage, wechat,
  wxInformMsg, wxNewsDetail, wxActivityDetail, dhShare, handOver, goodsReturn, capitalHandOver, addKeepRecord, bonusManage, OverseasTrain, trainLeaveApply, materialScrapApply,onlineEducation,projectStatistics
]